import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { checkAvailability, getItem, Emitter, getGlobal, setItem, removeItem } from '@monterosa-sdk/util';
import _defineProperty from '@babel/runtime/helpers/defineProperty';

var ARG_OVERRIDE_METHODS = 'enmasse_override_methods';
var ARG_DEBUG = 'enmasse_debug';
var ARG_CONFIG = 'enmasse_config';
var SSCP_KLASS_AUTH = 'auth';
var SSCP_KLASS_AUTHR = 'authr';
var SSCP_KLASS_AUTHOK = 'authok';
var SSCP_KLASS_PING = 'ping';
var SSCP_KLASS_SUB = 'sub';
var SSCP_KLASS_UNSUB = 'unsub';
var SSCP_KLASS_EOC = 'eoc';
var SSCP_KLASS_LOGIN = 'login';
var SSCP_KLASS_LOGIN_OK = 'login_ok';
var SSCP_KLASS_LOGIN_FAIL = 'login_fail';
var SSCP_KLASS_COUNTER = 'counter';

var getSettingFor = name => {
  if (checkAvailability()) {
    var value = getItem(name);

    if (value !== null) {
      return value;
    }
  } // Guarding the use of the window object in environments where it might not be
  // available, such as during server - side rendering in a framework like Next.js


  if (typeof window === 'undefined') {
    return null;
  }

  var _URL = new URL(window.location.href),
      searchParams = _URL.searchParams;

  if (searchParams.has(name)) {
    return searchParams.get(name);
  }

  return false;
};

var getSettingForMethods = () => {
  var value = getSettingFor(ARG_OVERRIDE_METHODS);

  if (value !== false) {
    return value.split(',');
  }

  return undefined;
};

var ENMASSE_OVERRIDE_METHODS = getSettingForMethods();
var ENMASSE_DEBUG = getSettingFor(ARG_DEBUG);
var ENMASSE_CONFIG = getSettingFor(ARG_CONFIG);

var version = "0.17.1";

/* eslint no-bitwise: "off" */
var TYPE_PROTOCOL = 1; // 0000 0000 0001

var TYPE_MANAGER = 2; // 0000 0000 0010

var TYPE_TRANSPORT = 4; // 0000 0000 0100

var TYPE_DRIVER = 8; // 0000 0000 1000

var TYPE_QUEUE = 16; // 0000 0001 0000

var TYPE_TIME = 32; // 0000 0010 0000

var TYPE_MANAGER_EXTRA = 64; // 0000 0100 0000

var TYPE_DRIVER_EXTRA = 128; // 0000 1000 0000

var TYPE_SERVICE = 256; // 0001 0000 0000

var LEVELS = {
  brief: TYPE_PROTOCOL,
  full: TYPE_PROTOCOL | TYPE_MANAGER | TYPE_TRANSPORT | TYPE_DRIVER,
  exhaustive: TYPE_PROTOCOL | TYPE_MANAGER | TYPE_MANAGER_EXTRA | TYPE_TRANSPORT | TYPE_DRIVER | TYPE_DRIVER_EXTRA | TYPE_QUEUE | TYPE_TIME | TYPE_SERVICE
}; // eslint-disable-next-line

var log = () => {};

if (ENMASSE_DEBUG) {
  log = function log() {
    if (typeof console === 'undefined' || !console.log) {
      return;
    } // parse arguments
    // var args = Array.prototype.slice.call(arguments);
    // the first argument is the debug type


    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var type = args[0]; // the rest of arguments are arbitrary data

    var rest = args.slice(1); // const time = ['getMinutes', 'getSeconds']
    //   .map((f) => new Date()[f]())
    //   .map((v) => (v < 10 ? '0' : '') + v)
    //   .join(':');
    // add current time
    // rest.unshift(time);
    // do not log if mask doesn't contain current type

    if ((LEVELS[ENMASSE_DEBUG] & type) === 0) {
      return;
    }

    console.log(...rest);
  };
}

class Queue {
  constructor() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // the main storage for messages
    this.queue = []; // stash of the queue

    this.stashed = [];
    this.running = false;
    this.runner = typeof config.runner === 'function' ? config.runner : null; // list of channels we subscribed to

    this.subscriptions = [];
  }

  push(message) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    log(TYPE_QUEUE, 'Queue::push', message, force);
    var klass = message.klass,
        channel = message.channel;

    if (!force) {
      switch (klass) {
        case SSCP_KLASS_LOGIN:
        case SSCP_KLASS_AUTHR:
          break;

        case SSCP_KLASS_SUB:
          if (this.subscriptions.indexOf(channel) === -1) {
            this.subscriptions.push(channel);
          } else {
            return;
          }

          break;

        case SSCP_KLASS_UNSUB:
          {
            var index = this.subscriptions.indexOf(channel);

            if (index !== -1) {
              this.subscriptions.splice(index, 1);
            } else {
              return;
            }

            break;
          }

        default:
          if (this.subscriptions.indexOf(channel) === -1) {
            return;
          }

          break;
      }
    }

    this.queue.push(message);
  }

  getSubscriptions() {
    return this.subscriptions;
  }

  run() {
    log(TYPE_QUEUE, 'Queue::run', "running=".concat(this.running, ", head=").concat(this.queue[0])); // abort if whether
    // 1. runner function is not set
    // 2. OR queue is already running
    // 3. OR there is no messages in the queue

    if (this.runner === null || this.running || !this.queue[0]) {
      return;
    }

    this.running = true;
    this.runner(this.queue.shift());
  }

  success() {
    log(TYPE_QUEUE, 'Queue::success');
    this.running = false;
    this.run();
  }

  failure() {
    log(TYPE_QUEUE, 'Queue::failure');
    this.running = false;
  }

  stash() {
    log(TYPE_QUEUE, 'Queue::stash');
    var item; // eslint-disable-next-line

    while (undefined !== (item = this.queue.shift())) {
      this.stashed.push(item);
    }
  }

  unstash() {
    log(TYPE_QUEUE, 'Queue::unstash');
    var item; // eslint-disable-next-line

    while (undefined !== (item = this.stashed.shift())) {
      this.queue.push(item);
    }
  }

}

var local = () => new Date() / 1000; // Server time default to local time


var serverTime = local(); // Time when the server time was received on the client

var clientTimeAtSync = local();
var setTime = newTime => {
  log(TYPE_TIME, 'Time::setTime', newTime);
  serverTime = newTime; // offset = local() - time;

  clientTimeAtSync = local();
};
var now = () => {
  var elapsedTime = local() - clientTimeAtSync;
  return Math.round(serverTime + elapsedTime);
};

class Transport extends Emitter {
  // generic events
  // connection state events
  // states
  constructor() {
    super();
    this.state = this.STATE_DISCONNECTED;
    this.trigger = this.emit;
    this.bind = this.on;
    this.unbind = this.off;
  }

}

_defineProperty(Transport, "ON_READY", 'ready');

_defineProperty(Transport, "ON_MESSAGE", 'message');

_defineProperty(Transport, "ON_CONNECTED", 'connected');

_defineProperty(Transport, "ON_CONNECT_FAILED", 'connect_failed');

_defineProperty(Transport, "ON_CONNECT_LOST", 'connect_lost');

_defineProperty(Transport, "ON_DISCONNECTED", 'disconnected');

_defineProperty(Transport, "STATE_CONNECTED", 'connected');

_defineProperty(Transport, "STATE_CONNECTING", 'connecting');

_defineProperty(Transport, "STATE_DISCONNECTED", 'disconnected');

_defineProperty(Transport, "STATE_DISCONNECTING", 'disconnecting');

class Driver extends Emitter {
  constructor() {
    super();
    this.connected = false;
    this.trigger = this.emit;
    this.bind = this.on;
    this.unbind = this.off;
  }

  connect() {}

  disconnect() {} // Arguments:
  //
  // data = null
  // success = () => {}
  // failure = () => {}


  send() {}

  init() {
    this.trigger(Driver.ON_READY);
  }

}

_defineProperty(Driver, "ON_READY", 'ready');

_defineProperty(Driver, "ON_MESSAGE", 'message');

_defineProperty(Driver, "ON_CONNECTED", 'connected');

_defineProperty(Driver, "ON_DISCONNECTED", 'disconnected');

var globals$1 = getGlobal();
class XHRDriver extends Driver {
  constructor() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    this.config = config;
    this.requests = {};
    this.requestIdx = 0;
  } // CORS request wrapper


  _request(url) {
    var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
    var failure = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
    var abort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : () => {};
    this.requestIdx += 1;
    log(TYPE_DRIVER_EXTRA, "XHRDriver::request url=".concat(url, ", idx=").concat(this.requestIdx));
    var self = this;
    var xhr = new XMLHttpRequest();
    var method = 'POST';

    if (typeof XDomainRequest !== 'undefined') {
      xhr = new XDomainRequest();
      xhr.open(method, url);
    } else if ('withCredentials' in xhr) {
      xhr.open(method, url, true);
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    } else {
      return null;
    }

    xhr._idx = this.requestIdx;

    xhr.onload = function onLoad() {
      log(TYPE_DRIVER_EXTRA, "XHRDriver::request::onload idx=".concat(xhr._idx, ", response=").concat(this.responseText));

      if (this.responseText.length > 0) {
        success(self._parseResponse(this.responseText));
      } else {
        failure(this.responseText);
      }
    };

    xhr.onerror = function onError() {
      log(TYPE_DRIVER_EXTRA, "XHRDriver::request::onerror idx=".concat(xhr._idx, ", response=").concat(this.responseText));
      failure(this.responseText);
    }; // XHR doesn't trigger onabort event in IE < 10
    // attaching custom abort handler and execute
    // it manually on each abort() call


    xhr._onabort = () => {
      log(TYPE_DRIVER_EXTRA, "XHRDriver::request::onabort idx=".concat(xhr._idx));
      abort();
    };

    return xhr;
  }

  _parseResponse(response) {
    var data = {};
    var chunks = response.split('&');

    for (var i = 0, l = chunks.length; i < l; i++) {
      var _chunks$i$split = chunks[i].split('='),
          _chunks$i$split2 = _slicedToArray(_chunks$i$split, 2),
          key = _chunks$i$split2[0],
          value = _chunks$i$split2[1];

      var normalisedValue = decodeURIComponent(value.replace('\0', ''));

      if (key in data) {
        if (data[key].constructor !== Array) {
          data[key] = [data[key]];
        }

        data[key].push(normalisedValue);
      } else {
        data[key] = normalisedValue;
      }
    }

    return data;
  }

  _removeRequest(idx) {
    log(TYPE_DRIVER_EXTRA, 'XHRDriver::removeRequest', idx);

    if (Object.prototype.hasOwnProperty.call(this.requests, idx)) {
      delete this.requests[idx];
    }
  }

  connect() {
    log(TYPE_DRIVER, 'XHRDriver::connect');

    if (this.connected) {
      log(TYPE_DRIVER, 'XHRDriver::connect already been connected!');
      return;
    }

    this.connected = true;
    this.trigger(XHRDriver.ON_CONNECTED);
  }

  disconnect() {
    log(TYPE_DRIVER, 'XHRDriver::disconnect');

    if (this.connected) {
      // abort all requests
      for (var idx in this.requests) {
        if (Object.prototype.hasOwnProperty.call(this.requests, idx) && this.requests[idx].abort) {
          this.requests[idx].abort();

          if (this.requests[idx]._onabort) {
            this.requests[idx]._onabort();
          }

          this._removeRequest(idx);
        }
      }

      this.connected = false;
    }

    this.trigger(XHRDriver.ON_DISCONNECTED);
  }

  send(url, data) {
    var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
    var failure = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : () => {};
    log(TYPE_DRIVER, 'XHRDriver::send', data);
    var xhr;
    var retry = 1;

    var send = () => {
      // eslint-disable-next-line
      xhr = this._request(url, onSuccess, onFailure, onAbort);
      this.requests[xhr._idx] = xhr; // fixes aborting requests in IE

      setTimeout(() => {
        xhr.send(data);
      }, 0);
    };

    var onSuccess = response => {
      log(TYPE_DRIVER, 'XHRDriver::success', data);

      this._removeRequest(xhr._idx);

      success(response);
    };

    var onFailure = response => {
      log(TYPE_DRIVER, 'XHRDriver::failure, retry: ', retry);

      this._removeRequest(xhr._idx);

      if (retry <= this.config.request_retries) {
        setTimeout(() => {
          send();
          retry++;
        }, this.config.request_retry_delay * 1000);
      } else {
        failure(response);
      }
    };

    var onAbort = () => {
      log(TYPE_DRIVER, 'XHRDriver::abort', data);

      this._removeRequest(xhr._idx);

      failure();
    };

    send();
  }

  static hasSupport() {
    return 'XDomainRequest' in globals$1 || 'withCredentials' in new XMLHttpRequest();
  }

}

/* eslint class-methods-use-this: "off" */
var globals = getGlobal();
class WebSocketDriver extends Driver {
  constructor() {
    super();
    this.websocket = null;
    this.closeTimeout = null;
  }

  _onMessage(e) {
    log(TYPE_DRIVER, 'WebSocketDriver::onMessage', e.data);
    this.trigger(WebSocketDriver.ON_MESSAGE, e.data);
  }

  _onOpen() {
    log(TYPE_DRIVER, 'WebSocketDriver::onOpen');
    this.connected = true;
    this.trigger(WebSocketDriver.ON_CONNECTED);
  }

  _onClose() {
    log(TYPE_DRIVER, 'WebSocketDriver::onClose');

    this._disconnect();
  }

  _onError() {
    log(TYPE_DRIVER, 'WebSocketDriver::onError');
  }

  _disconnect() {
    log(TYPE_DRIVER, 'WebSocketDriver::disconnect');
    this.connected = false; // reset handlers if websocket was created

    if (this.websocket !== null) {
      this.websocket.onmessage = () => {};

      this.websocket.onopen = () => {};

      this.websocket.onclose = () => {};

      this.websocket.onerror = () => {};

      this.websocket = null;
    }

    clearTimeout(this.closeTimeout);
    this.trigger(WebSocketDriver.ON_DISCONNECTED);
  }

  connect(host, port, secure) {
    if (this.connected) {
      return;
    }

    log(TYPE_DRIVER, 'WebSocketDriver::connect', host, port);
    var url = "".concat(secure ? 'wss' : 'ws', "://").concat(host, ":").concat(port, "/ws");
    this.websocket = new WebSocket(url);
    this.websocket.onmessage = this._onMessage.bind(this);
    this.websocket.onopen = this._onOpen.bind(this);
    this.websocket.onclose = this._onClose.bind(this);
    this.websocket.onerror = this._onError.bind(this);
  }

  disconnect() {
    log(TYPE_DRIVER, 'WebSocketDriver::disconnect');

    if (this.connected) {
      // ON_DISCONNECTED will be triggered at onClose event
      this.websocket.close(); // websocket does not fire onclose if network connection is lost
      // set timeout to force fire ON_DISCONNECTED event

      this.closeTimeout = setTimeout(this._disconnect.bind(this), 750);
    } else {
      // disconnect instantly if websocket wasn't connected or still connecting
      this._disconnect();
    }
  }

  send(data) {
    var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
    log(TYPE_DRIVER, 'WebSocketDriver::send', data);
    this.websocket.send(data);
    success();
  }

  static hasSupport() {
    return 'WebSocket' in globals;
  }

}

var COMMAND_CONNECT = 'connect';
var COMMAND_PASS = 'pass';
var COMMAND_POLL = 'poll';
class ProxyTransport extends Transport {
  constructor() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    log(TYPE_TRANSPORT, 'ProxyTransport::constructor', config);
    super(config);
    this.driver = config.driver || null;
    this.host = config.host || null;
    this.port = config.port || null;
    this.secure = config.secure || false;
    /*
     * Proxy properties
     * host and port should be always preserved on connect and reconnect
     * drop proxyIp, childId and clientId on reconnect and disconnect
     */

    this.proxyIp = null;
    this.childId = null;
    this.clientId = null;
    this.sessionId = null;
    this.driver.bind(Driver.ON_READY, this._handleDriverReady.bind(this));
    this.driver.bind(Driver.ON_CONNECTED, this._handleDriverConnected.bind(this));
    this.driver.bind(Driver.ON_DISCONNECTED, this._handleDriverDisconnected.bind(this));
  }

  _url() {
    return "".concat(this.secure ? 'https' : 'http', "://") + "".concat(this.proxyIp ? this.proxyIp : this.host, ":") + "".concat(this.port, "/") + "".concat(this.childId !== null ? "".concat(this.childId, "/") : '') + "?_r=".concat(new Date().getTime());
  }

  _request() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
    var failure = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
    var self = this;

    var onSuccess = response => {
      // fire ON_MESSAGE event unless sscp message is empty
      if (response.sscp.constructor === String) {
        response.sscp = [response.sscp];
      }

      for (var i = 0, l = response.sscp.length; i < l; i++) {
        if (response.sscp[i] !== '') {
          self.trigger(ProxyTransport.ON_MESSAGE, response.sscp[i]);
        }
      }

      success(response);
    };

    var onFailure = () => {
      switch (self.state) {
        case ProxyTransport.STATE_CONNECTED:
          self.state = ProxyTransport.STATE_DISCONNECTING;
          self.trigger(ProxyTransport.ON_CONNECT_FAILED);
          break;

        case ProxyTransport.STATE_CONNECTING:
          self.state = ProxyTransport.STATE_DISCONNECTING;
          self.trigger(ProxyTransport.ON_CONNECT_FAILED);
          break;

        case ProxyTransport.STATE_DISCONNECTING:
          self.state = ProxyTransport.STATE_DISCONNECTED;
          self.trigger(ProxyTransport.ON_DISCONNECTED);
          break;
      }

      failure();
    };

    this.driver.send(this._url(), params, onSuccess, onFailure);
  }

  _poll() {
    var params = "command=".concat(COMMAND_POLL) + "&clientid=".concat(this.clientId) + "&sid=".concat(this.sessionId);

    this._request(params, this._poll.bind(this));
  }

  _connect() {
    var self = this;

    var onSuccess = response => {
      self.proxyIp = response.proxy;
      self.clientId = parseInt(response.clientid, 10);
      self.childId = parseInt(response.childid, 10);
      self.sessionId = response.sid;
      self.state = ProxyTransport.STATE_CONNECTED;
      self.trigger(ProxyTransport.ON_CONNECTED);

      self._poll();
    };

    var onFailure = () => {
      self.state = ProxyTransport.STATE_DISCONNECTED;
      self.trigger(ProxyTransport.ON_CONNECT_FAILED);
    };

    var params = "command=".concat(COMMAND_CONNECT);

    this._request(params, onSuccess, onFailure);
  }

  _handleDriverReady() {
    this.trigger(ProxyTransport.ON_READY);
  }

  _handleDriverConnected() {
    this._connect();
  }

  _handleDriverDisconnected() {
    log(TYPE_TRANSPORT, 'ProxyTransport::handleDriverDisconnected');
    var state = this.state;
    this.state = ProxyTransport.STATE_DISCONNECTED;

    switch (state) {
      case ProxyTransport.STATE_CONNECTED:
        this.trigger(ProxyTransport.ON_CONNECT_LOST);
        break;

      case ProxyTransport.STATE_CONNECTING:
        this.trigger(ProxyTransport.ON_CONNECT_FAILED);
        break;

      case ProxyTransport.STATE_DISCONNECTING:
        this.trigger(ProxyTransport.ON_DISCONNECTED);
        break;
    }
  }

  send(sscp) {
    var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
    var failure = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
    log(TYPE_TRANSPORT, 'ProxyTransport::send', sscp);
    var params = "command=".concat(COMMAND_PASS) + "&clientid=".concat(this.clientId) + "&sscp=".concat(sscp) + "&sid=".concat(this.sessionId);

    this._request(params, success, failure);
  }

  connect() {
    log(TYPE_TRANSPORT, 'ProxyTransport::connect', this.host, this.port);
    this.state = ProxyTransport.STATE_CONNECTING;
    this.driver.connect();
  }

  disconnect() {
    log(TYPE_TRANSPORT, 'ProxyTransport::disconnect'); // drop proxy settings

    this.proxyIp = null;
    this.childId = null;
    this.sessionId = null;
    this.state = ProxyTransport.STATE_DISCONNECTING;
    this.driver.disconnect();
  }

  init() {
    log(TYPE_TRANSPORT, 'ProxyTransport::init');
    this.driver.init();
  }

}

class SocketTransport extends Transport {
  constructor() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    log(TYPE_TRANSPORT, 'SocketTransport::constructor', config);
    super();
    this.driver = config.driver || null;
    this.host = config.host || null;
    this.port = config.port || null;
    this.secure = config.secure || false;
    this.driver.bind(Driver.ON_READY, this._handleDriverReady.bind(this));
    this.driver.bind(Driver.ON_MESSAGE, this._handleDriverMessage.bind(this));
    this.driver.bind(Driver.ON_CONNECTED, this._handleDriverConnected.bind(this));
    this.driver.bind(Driver.ON_DISCONNECTED, this._handleDriverDisconnected.bind(this));
  }

  _handleDriverReady() {
    log(TYPE_TRANSPORT, 'SocketTransport::_handleDriverReady');
    this.trigger(SocketTransport.ON_READY);
  }

  _handleDriverMessage(message) {
    log(TYPE_TRANSPORT, 'SocketTransport::handleDriverMessage');
    this.trigger(SocketTransport.ON_MESSAGE, message);
  }

  _handleDriverConnected() {
    log(TYPE_TRANSPORT, 'SocketTransport::handleDriverConnected');
    this.state = SocketTransport.STATE_CONNECTED;
    this.trigger(SocketTransport.ON_CONNECTED);
  }

  _handleDriverDisconnected() {
    log(TYPE_TRANSPORT, 'SocketTransport::handleDriverDisconnected');
    var state = this.state;
    this.state = SocketTransport.STATE_DISCONNECTED;

    switch (state) {
      case SocketTransport.STATE_CONNECTED:
        this.trigger(SocketTransport.ON_CONNECT_LOST);
        break;

      case SocketTransport.STATE_CONNECTING:
        this.trigger(SocketTransport.ON_CONNECT_FAILED);
        break;

      case SocketTransport.STATE_DISCONNECTING:
        this.trigger(SocketTransport.ON_DISCONNECTED);
        break;
    }
  }

  send(sscp) {
    var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
    var failure = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
    log(TYPE_TRANSPORT, 'SocketTransport::send', sscp);
    this.driver.send(sscp, success, failure);
  }

  connect() {
    log(TYPE_TRANSPORT, 'SocketTransport::connect', this.host, this.port);
    this.state = SocketTransport.STATE_CONNECTING;
    this.driver.connect(this.host, this.port, this.secure);
  }

  disconnect() {
    log(TYPE_TRANSPORT, 'SocketTransport::disconnect');
    this.state = SocketTransport.STATE_DISCONNECTING;
    this.driver.disconnect();
  }

  init() {
    log(TYPE_TRANSPORT, 'SocketTransport::init');
    this.driver.init();
  }

}

var METHOD_PROXY = 'proxy';
var METHOD_WEBSOCKET = 'websocket';

class TransportManager extends Emitter {
  constructor() {
    super();
    this.trigger = this.emit;
    this.bind = this.on;
    this.unbind = this.off;
    this.ON_READY = 'ready';
    this.config = null;
    this.idx = 0; // list of connection types pairs: transport - driver

    this.methods = {};
    this.transports = {};
    this.loaded = 0;
    this.sequence = [];
    this.allowed = [];
    this.secure = true; // Guarding the use of the window object in environments where it might
    // not be available, such as during server - side rendering in a framework
    // like Next.js

    if (typeof window !== 'undefined') {
      this.secure = window.location.protocol.indexOf('https') === 0;
    } // list of connection methods which where unsuccessful


    this.unsuccessful = [];
  }

  _instantiate() {
    log(TYPE_MANAGER, 'TransportManager::instantiate'); // instantiate all transports

    this.allowed.forEach(method => {
      var config = this._getMethodConfig(method); // pick the random host


      var host = config.hosts[Math.floor(Math.random() * config.hosts.length)];
      var TransportKlass = this.methods[method].transport;
      var DriverKlass = this.methods[method].driver;
      var transport = new TransportKlass({
        driver: new DriverKlass(config.driver || {}),
        host,
        port: this.secure ? config.secure_port : config.port,
        secure: this.secure
      });
      this.transports[method] = transport;
      transport.bind(Transport.ON_READY, this._handleTransportReady.bind(this));
    }, this); // initialise all transports

    for (var method in this.transports) {
      if (Object.prototype.hasOwnProperty.call(this.transports, method)) {
        this.transports[method].init();
      }
    }
  }

  _getMethodConfig(method) {
    return this.config.methods.find(item => item.type === method);
  }

  _handleTransportReady() {
    this.loaded += 1;

    if (this.loaded === this.allowed.length) {
      this.trigger(this.ON_READY);
    }
  }

  current() {
    return this.transports[this.allowed[this.idx]];
  }

  next() {
    this.idx += 1;

    if (this.idx >= this.allowed.length) {
      return false;
    }

    return this.current();
  }

  reset() {
    this.allowed = [];
    this.unsuccessful = []; // gather all methods in one array in correct connection sequence

    for (var i = 0, l = this.sequence.length; i < l; i += 1) {
      // shift method's idx by the value of the current method idx
      var method = this.sequence[(i + this.idx) % l];

      if (this.methods[method].driver.hasSupport()) {
        this.allowed.push(method);
      }
    }

    this.idx = 0;
  }

  addUnsuccessful(transport) {
    for (var method in this.transports) {
      if (Object.prototype.hasOwnProperty.call(this.transports, method) && this.transports[method] === transport) {
        this.unsuccessful.push(method);
      }
    }
  }

  init() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.config = config;
    this.idx = 0;
    this.loaded = 0;
    this.sequence = [];
    this.secure = config.forceSecure === true ? true : this.secure;
    this.methods[METHOD_PROXY] = {
      driver: XHRDriver,
      transport: ProxyTransport
    };
    this.methods[METHOD_WEBSOCKET] = {
      driver: WebSocketDriver,
      transport: SocketTransport
    };

    if (ENMASSE_OVERRIDE_METHODS) {
      this.sequence = ENMASSE_OVERRIDE_METHODS;
    } else {
      this.config.methods.forEach(method => this.sequence.push(method.type), this);
    } // remove unsupported methods

    /* eslint-disable */


    this.sequence = this.sequence.filter(item => Object.prototype.hasOwnProperty.call(this.methods, item));
    /* eslint-enable */

    this.reset();

    this._instantiate();
  }

}

var TransportManager$1 = new TransportManager();

/* eslint @typescript-eslint/no-use-before-define: ["error", { "variables": false }] */

var ConnectionManager = (() => {
  var self = new Emitter();
  self.trigger = self.emit;
  self.bind = self.on;
  self.unbind = self.off;
  /*
   * Constants
   */

  var CONNECT_DELAYS = [0, 3, 5, 10, 20, 30, 45, 60];
  /*
   * States
   */

  self.STATE_DISCONNECTED = 'state_disconnected';
  self.STATE_DISCONNECTING = 'state_disconnecting';
  self.STATE_CONNECTING = 'state_connecting';
  self.STATE_CONNECTED = 'state_connected';
  /*
   * Events
   */

  self.ON_MESSAGE = 'message';
  self.ON_STATE = 'state';
  /*
   * Private variables
   */

  var config = null;
  var state = self.STATE_DISCONNECTED;
  var transport = null;
  var attempt = 1; // Timestamp to track when the app was backgrounded

  var backgroundedAt = null;
  var inactivityTimeout = {
    start() {
      log(TYPE_MANAGER_EXTRA, 'ConnectionManager::inactivityTimeout::start');
      var stamp = now();
      this.interval = setInterval(() => {
        if (now() - stamp >= config.inactivity_timeout) {
          this.resolve();
        }
      }, 1000);
    },

    stop() {
      log(TYPE_MANAGER_EXTRA, 'ConnectionManager::inactivityTimeout::stop');
      clearInterval(this.interval);
    },

    reset() {
      log(TYPE_MANAGER_EXTRA, 'ConnectionManager::inactivityTimeout::reset');
      this.stop();
      this.start();
    },

    resolve() {
      log(TYPE_MANAGER_EXTRA, 'ConnectionManager::inactivityTimeout::resolve');
      disconnectingOnConnectLost();
    }

  };
  var connectTimeout = {
    start() {
      log(TYPE_MANAGER_EXTRA, 'ConnectionManager::connectTimeout::start');
      this.timeout = setTimeout(() => {
        this.resolve();
      }, config.connect_timeout * 1000);
    },

    stop() {
      log(TYPE_MANAGER_EXTRA, 'ConnectionManager::connectTimeout::stop');
      clearTimeout(this.timeout);
    },

    resolve() {
      log(TYPE_MANAGER_EXTRA, 'ConnectionManager::connectTimeout::resolve');
      disconnectingOnConnectFailed();
    }

  };
  var connectDelay = {
    active: false,

    start(delay) {
      log(TYPE_MANAGER_EXTRA, 'ConnectionManager::connectDelay::start');
      this.active = true;
      this.timeout = setTimeout(() => {
        this.resolve();
      }, delay * 1000);
    },

    stop() {
      log(TYPE_MANAGER_EXTRA, 'ConnectionManager::connectDelay::stop');
      this.active = false;
      clearTimeout(this.timeout);
    },

    resolve() {
      log(TYPE_MANAGER_EXTRA, 'ConnectionManager::connectDelay::resolve');
      this.stop();
      connect();
    }

  };

  var initTransport = newTransport => {
    log(TYPE_MANAGER, 'ConnectionManager::initTransport');
    transport = newTransport;
    transport.bind(Transport.ON_MESSAGE, handleTransportMessage);
    transport.bind(Transport.ON_CONNECTED, handleTransportConnected);
    transport.bind(Transport.ON_CONNECT_FAILED, handleTransportConnectFailed);
    transport.bind(Transport.ON_CONNECT_LOST, handleTransportConnectLost);
    transport.bind(Transport.ON_DISCONNECTED, handleTransportDisconnected);
  };

  var teardownTransport = () => {
    log(TYPE_MANAGER, 'ConnectionManager::teardownTransport');

    if (transport === null) {
      return;
    }

    transport.unbind(Transport.ON_MESSAGE, handleTransportMessage);
    transport.unbind(Transport.ON_CONNECTED, handleTransportConnected);
    transport.unbind(Transport.ON_CONNECT_FAILED, handleTransportConnectFailed);
    transport.unbind(Transport.ON_CONNECT_LOST, handleTransportConnectLost);
    transport.unbind(Transport.ON_DISCONNECTED, handleTransportDisconnected);
    transport = null;
  };

  var handleTransportMessage = message => {
    log(TYPE_MANAGER, 'ConnectionManager::handleTransportMessage', message);
    var messages = message.split('\0');

    for (var i = 0; i < messages.length; i += 1) {
      if (messages[i].length > 0) {
        inactivityTimeout.reset();
        log(TYPE_MANAGER, 'ConnectionManager::handleTransportMessage', 'send upstream m:', messages[i]);
        self.trigger(self.ON_MESSAGE, messages[i]);
      }
    }
  };

  var handleTransportConnected = () => {
    log(TYPE_MANAGER, 'ConnectionManager::handleTransportConnected');
    setStateToConnected();
  };

  var handleTransportConnectFailed = () => {
    log(TYPE_MANAGER, 'ConnectionManager::handleTransportConnectFailed');
    disconnectingOnConnectFailed();
  };

  var handleTransportConnectLost = () => {
    log(TYPE_MANAGER, 'ConnectionManager::handleTransportConnectLost');
    disconnectingOnConnectLost();
  };

  var handleTransportDisconnected = () => {
    log(TYPE_MANAGER, 'ConnectionManager::handleTransportDisconnected');

    switch (state) {
      case self.STATE_CONNECTED:
        disconnectedOnConnectLost();
        break;

      case self.STATE_CONNECTING:
        disconnectedOnConnectFailed();
        break;

      case self.STATE_DISCONNECTING:
        setStateToDisconnected();
        break;
    }
  };

  var disconnectingOnConnectFailed = () => {
    log(TYPE_MANAGER, 'ConnectionManager::disconnectingOnConnectFailed()');
    disconnect();
  };

  var disconnectingOnConnectLost = () => {
    log(TYPE_MANAGER, 'ConnectionManager::disconnectingOnConnectLost()');
    disconnect();
  };

  var disconnectedOnConnectLost = () => {
    log(TYPE_MANAGER, 'ConnectionManager::disconnectedOnConnectLost()');
    teardownTransport(); // automatically reconnect

    setStateToConnecting();
  };

  var disconnectedOnConnectFailed = () => {
    log(TYPE_MANAGER, 'ConnectionManager::disconnectedOnConnectFailed()');
    TransportManager$1.addUnsuccessful(transport);
    teardownTransport();

    if (TransportManager$1.next() === false) {
      setStateToConnecting();
    } else {
      connect();
    }
  };

  var setStateToConnecting = () => {
    log(TYPE_MANAGER, 'ConnectionManager::setStateToConnecting()');
    var delay;

    if (attempt >= CONNECT_DELAYS.length) {
      delay = CONNECT_DELAYS[CONNECT_DELAYS.length - 1];
    } else {
      delay = CONNECT_DELAYS[attempt - 1];
    }

    state = self.STATE_CONNECTING;
    self.trigger(self.ON_STATE, state, attempt, delay);
    TransportManager$1.reset();
    attempt += 1;
    connectDelay.start(delay);
  };

  var setStateToConnected = () => {
    log(TYPE_MANAGER, 'ConnectionManager::setStateToConnected()');
    attempt = 1;
    TransportManager$1.reset();
    inactivityTimeout.reset();
    connectTimeout.stop();
    connectDelay.stop();
    state = self.STATE_CONNECTED;
    self.trigger(self.ON_STATE, state);
  };

  var setStateToDisconnecting = () => {
    log(TYPE_MANAGER, 'ConnectionManager::setStateToDisconnecting()');
    state = self.STATE_DISCONNECTING;
    self.trigger(self.ON_STATE, state);
    disconnect();
  };

  var setStateToDisconnected = () => {
    log(TYPE_MANAGER, 'ConnectionManager::setStateToDisconnected()');
    attempt = 1;
    teardownTransport();
    TransportManager$1.reset();
    state = self.STATE_DISCONNECTED;
    self.trigger(self.ON_STATE, state);
  };

  var connect = () => {
    if (state === self.STATE_CONNECTING) {
      connectTimeout.start();
      initTransport(TransportManager$1.current());
      transport.connect();
    }
  };

  var disconnect = () => {
    inactivityTimeout.stop();
    connectTimeout.stop();
    connectDelay.stop();

    if (transport) {
      transport.disconnect();
    } else {
      setStateToDisconnected();
    }
  };
  /**
   * Handles changes in the document's visibility state (visible/hidden).
   *
   * - Tracks when the document is backgrounded by recording the timestamp.
   * - When the document becomes visible again, checks if the time spent in the background
   *   exceeds a configured timeout. If it does, the connection is disconnected.
   * - Ensures actions are only taken if necessary, based on the current connection state
   *   and whether the page was previously backgrounded.
   *
   * Note on Safari (ios and desktop) and Firefox quirk: visibilitychange event is fired
   * immidiately when the page is loaded, even if the page is visible.
   */


  var handleVisibilityChange = () => {
    log(TYPE_MANAGER, 'ConnectionManager::handleVisibilityChange()', document.visibilityState);

    switch (document.visibilityState) {
      case 'visible':
        if (backgroundedAt === null) {
          return;
        }

        if (state !== self.STATE_CONNECTED) {
          return;
        }

        if (Date.now() - backgroundedAt > config.background_timeout * 1000) {
          log(TYPE_MANAGER, 'ConnectionManager::handleVisibilityChange()', 'disconnecting due to background timeout');
          disconnect();
        }

        backgroundedAt = null;
        break;

      case 'hidden':
        backgroundedAt = Date.now();
        break;
    }
  };

  var handleNetworkStatus = () => {
    if (!navigator.onLine && state === self.STATE_CONNECTED) {
      log(TYPE_MANAGER, 'ConnectionManager::handleNetworkStatus()', 'disconnecting due to network loss');
      disconnect();
    }
  };

  self.connect = () => {
    log(TYPE_MANAGER, 'ConnectionManager::connect()'); // resolve connect instantly if the process has been already postponed

    if (connectDelay.active) {
      connectDelay.resolve();
    } else if (state === self.STATE_DISCONNECTED) {
      setStateToConnecting();
    }

    window.addEventListener('online', handleNetworkStatus);
    window.addEventListener('offline', handleNetworkStatus);
    window.addEventListener('visibilitychange', handleVisibilityChange);
  };

  self.disconnect = () => {
    log(TYPE_MANAGER, 'ConnectionManager::disconnect()');
    setStateToDisconnecting();
    window.removeEventListener('online', handleNetworkStatus);
    window.removeEventListener('offline', handleNetworkStatus);
    window.removeEventListener('visibilitychange', handleVisibilityChange);
  };

  self.send = (sscp, success, failure) => {
    log(TYPE_MANAGER, 'ConnectionManager::send', sscp);

    success = success || (() => {});

    failure = failure || (() => {});

    transport.send(sscp, success, failure);
  };

  self.getConnectAttempt = () => attempt;

  self.init = cfg => {
    log(TYPE_MANAGER, 'ConnectionManager::init()', cfg);
    config = cfg;
  };

  return self;
})();

/* eslint-disable no-console */

class Demographics extends Emitter {
  constructor() {
    super(...arguments);
    this.ON_ADD_COUNTER = 'add-counter';
    this.trigger = this.emit;
    this.bind = this.on;
    this.unbind = this.off;
  }

  addCounter(channel, eventId, segment, counter) {
    var round = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var min = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var max = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    log(TYPE_SERVICE, 'Demographics::addCounter', channel, eventId, segment, counter, round, min, max);

    if (!channel) {
      return;
    }

    if (!eventId) {
      return;
    }

    if (!segment || segment.constructor !== Array || !segment.length || segment.length % 2 !== 0) {
      return;
    }

    if (counter !== parseInt(counter, 10)) {
      return;
    }

    var keys = segment.filter((v, i) => (i + 1) % 2).join(':');
    var values = segment.filter((v, i) => i % 2).join(':');
    this.trigger(this.ON_ADD_COUNTER, channel, [eventId, min, max, round, keys, values, counter]);
  }

}

var Demographics$1 = new Demographics();

var Enmasse = (() => {
  /*
   * Link to the scope
   */
  var self = new Emitter();
  self.trigger = self.emit;
  self.bind = self.on;
  self.unbind = self.off;
  /*
   * Constants
   */

  self.VERSION = version;
  self.PROTOCOL_VERSION = '8';
  self.SSCP_KLASS_AUTH = SSCP_KLASS_AUTH;
  self.SSCP_KLASS_AUTHR = SSCP_KLASS_AUTHR;
  self.SSCP_KLASS_AUTHOK = SSCP_KLASS_AUTHOK;
  self.SSCP_KLASS_PING = SSCP_KLASS_PING;
  self.SSCP_KLASS_SUB = SSCP_KLASS_SUB;
  self.SSCP_KLASS_UNSUB = SSCP_KLASS_UNSUB;
  self.SSCP_KLASS_EOC = SSCP_KLASS_EOC;
  self.SSCP_KLASS_LOGIN = SSCP_KLASS_LOGIN;
  self.SSCP_KLASS_COUNTER = SSCP_KLASS_COUNTER;
  self.ON_STATE = 'on_state';
  self.ON_MESSAGE = 'on_message';
  self.ON_EOC = 'on_eoc';
  self.ON_READY = 'on_ready';
  self.ON_ERROR = 'on_error';
  self.STATE_DISCONNECTED = 'disconnected';
  self.STATE_CONNECTED = 'connected';
  self.STATE_CONNECTING = 'connecting';
  self.Demographics = Demographics$1; // var CALLBACK_NAME       = "__enmasse_callback";
  // var CONFIG_TIMEOUT      = 5000;

  var PARAM_SESSION_ID = 'enmasse_session_id';
  /*
   * Enmasse properties
   */
  // Link to the config file.

  var configFile = null; // list of arbitray data passed into handshake
  // message along with the protocol version

  var info = []; // session id is generated by server and passed
  // on client on handshake

  var sessionId = null; // out messages queue

  var queue = null; // current state of the state machine

  var state = self.STATE_DISCONNECTED; // system channel

  var sysChannel = null; // force secure connection

  var forceSecure = false; // sign in promise object

  var loginContext = {
    inProgress: false,
    success: () => {},
    failure: () => {}
  };
  /*
   * Private methods
   */

  var storeSession = id => {
    if (checkAvailability()) {
      setItem(PARAM_SESSION_ID, id);
    }
  };

  var recoverSession = () => {
    if (checkAvailability()) {
      return getItem(PARAM_SESSION_ID);
    }

    return null;
  };

  var resetSession = () => {
    sessionId = null;

    if (checkAvailability()) {
      removeItem(PARAM_SESSION_ID);
    }
  };

  var validateSession = id => // eslint-disable-next-line
  /^[a-f\d]{8}\-[a-f\d]{4}\-[a-f\d]{4}-[a-f\d]{4}\-[a-f\d]{12}$/i.test(id);

  var finaliseLogin = callback => {
    if (loginContext.inProgress === false) {
      return;
    }

    loginContext = {
      inProgress: false,
      success: () => {},
      failure: () => {}
    };
    callback();
  };

  var resolveLogin = () => {
    finaliseLogin(loginContext.success);
  };

  var rejectLogin = () => {
    finaliseLogin(loginContext.failure);
  };

  var setStateToDisconnected = () => {
    log(TYPE_PROTOCOL, 'Enmasse::setStateToDisconnected()');
    state = self.STATE_DISCONNECTED;
    sysChannel = null;
    rejectLogin();
    self.trigger(self.ON_STATE, state);
  };

  var setStateToConnected = () => {
    log(TYPE_PROTOCOL, 'Enmasse::setStateToConnected()');
    var time = now();
    state = self.STATE_CONNECTED;
    self.trigger(self.ON_STATE, state, time);
  };

  var setStateToConnecting = (attempt, delay) => {
    log(TYPE_PROTOCOL, 'Enmasse::setStateToConnecting()');
    state = self.STATE_CONNECTING;
    rejectLogin();
    self.trigger(self.ON_STATE, state, attempt, delay);
  };

  var parseSSCP = sscp => {
    var data = {
      channel: 0,
      klass: '',
      sent_at: 0,
      body: []
    };
    var separator1 = sscp.indexOf('/');

    if (separator1 !== -1) {
      var separator2 = sscp.indexOf('/', separator1 + 1);

      if (separator2 !== -1) {
        data.channel = sscp.substr(0, separator1);
        data.klass = sscp.substr(separator1 + 1, separator2 - separator1 - 1);
        var separator3 = sscp.indexOf('/', separator2 + 1);

        if (separator3 !== -1) {
          data.sent_at = parseInt(sscp.substr(separator2 + 1, separator3 - separator2 - 1), 10);
          var body = sscp.substr(separator3 + 1);

          if (body !== '') {
            var values = body.split('|');

            for (var i = 0, l = values.length; i < l; i += 1) {
              data.body[i] = decodeURIComponent(values[i]);
            }
          }
        }
      }
    }

    return data;
  };

  var stringifySSCP = message => [message.channel, message.klass, Math.floor(new Date() / 1000), message.body.join('|')].join('/');

  var runner = message => {
    var success = () => {
      queue.success();
    };

    var failure = () => {
      queue.failure();
    };

    ConnectionManager.send(stringifySSCP(message), success, failure);
  };

  var handleTransportManagerReady = () => {
    log(TYPE_PROTOCOL, 'Enmasse::handleTransportManagerReady');
    self.trigger(self.ON_READY);
  };

  var handleConnectionManagerState = function handleConnectionManagerState() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    log(TYPE_PROTOCOL, 'Enmasse::handleConnectionManagerState', args);

    switch (args[0]) {
      // case ConnectionManager.STATE_DISCONNECTING:
      // break;
      case ConnectionManager.STATE_DISCONNECTED:
        setStateToDisconnected();
        break;

      case ConnectionManager.STATE_CONNECTING:
        setStateToConnecting(args[1], args[2]);
        break;

      case ConnectionManager.STATE_CONNECTED:
        break;
    }
  };

  var handleConnectionManagerMessage = message => {
    log(TYPE_PROTOCOL, 'Enmasse::handleConnectionManagerMessage', message);
    var data = parseSSCP(message);

    switch (data.klass) {
      case SSCP_KLASS_AUTH:
        {
          var time = data.sent_at;
          var clientInfo = ["enmassejs-".concat(self.VERSION), navigator.userAgent].concat(info); // store system channel

          sysChannel = data.channel; // url encode each client info item

          clientInfo.forEach((item, idx) => {
            clientInfo[idx] = encodeURIComponent(item);
          });

          if (sessionId === null) {
            var _data$body = _slicedToArray(data.body, 1);

            sessionId = _data$body[0];
            storeSession(sessionId);
          }

          setTime(time);
          queue.stash();
          queue.push({
            channel: sysChannel,
            klass: SSCP_KLASS_AUTHR,
            body: [sessionId, self.PROTOCOL_VERSION, clientInfo.join(',')]
          }, true);
          queue.run();
          break;
        }

      case SSCP_KLASS_AUTHOK:
        {
          // We have to resubscribe to the previously
          // subscribed channels after the reconnect.
          var subscriptions = queue.getSubscriptions();
          subscriptions.forEach(channel => {
            queue.push({
              channel,
              klass: SSCP_KLASS_SUB,
              body: []
            }, true);
          });
          queue.unstash();
          queue.run();
          setStateToConnected();
          break;
        }

      case SSCP_KLASS_LOGIN_OK:
        resolveLogin();
        break;

      case SSCP_KLASS_LOGIN_FAIL:
        rejectLogin();
        break;

      case SSCP_KLASS_PING:
        // ignoring ping message handling
        break;

      case SSCP_KLASS_EOC:
        self.trigger(self.ON_EOC, data.channel);
        break;

      default:
        self.trigger(self.ON_MESSAGE, data);
        break;
    }
  };

  var handleDemographicsCounter = (channel, data) => {
    self.send(channel, 'avgcounter', data);
  };
  /*
   * Public methods
   */


  self.connect = () => {
    log(TYPE_PROTOCOL, 'Enmasse::connect');
    ConnectionManager.connect();
  };

  self.disconnect = () => {
    log(TYPE_PROTOCOL, 'Enmasse:disconnect');
    ConnectionManager.disconnect();
  };

  self.send = (channel, klass, body) => {
    log(TYPE_PROTOCOL, 'Enmasse::send', channel, klass, body);
    body = body || [];
    queue.push({
      channel,
      klass,
      body
    });

    if (state === self.STATE_CONNECTED) {
      queue.run();
    }
  };

  self.getSessionId = () => sessionId;

  self.getState = () => state;

  self.subscribe = channel => {
    self.send(channel, SSCP_KLASS_SUB);
  };

  self.unsubscribe = channel => {
    self.send(channel, SSCP_KLASS_UNSUB);
  };

  self.login = function (userId, timestamp, signature) {
    var success = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : () => {};
    var failure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : () => {};

    if (sysChannel === null) {
      return;
    }

    if (loginContext.inProgress) {
      console.warn('Login is already in progress');
      return;
    }

    loginContext = {
      inProgress: true,
      success,
      failure
    };
    self.send(sysChannel, SSCP_KLASS_LOGIN, [userId, timestamp, signature]);
  };

  self.signIn = function () {
    console.warn( // eslint-disable-next-line
    "signIn() method is deprecated and will be removed in future versions. Please use login() method instead");

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    self.login(args);
  };

  self.init = /*#__PURE__*/function () {
    var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var config,
          response,
          status,
          text,
          data,
          isSuccess,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              config = _args.length > 0 && _args[0] !== undefined ? _args[0] : () => {};
              // config file is passed either as GET parameter or via constructor
              configFile = !ENMASSE_CONFIG ? config.config || null : ENMASSE_CONFIG;
              info = config.info || [];
              sessionId = recoverSession();

              if (typeof config.forceSecure === 'boolean') {
                forceSecure = config.forceSecure;
              }

              if (!(configFile === null)) {
                _context.next = 7;
                break;
              }

              throw 'Enmasse config file is not set';

            case 7:
              // If session id has invalid format
              if (sessionId !== null && !validateSession(sessionId)) {
                resetSession();
              }

              queue = new Queue({
                runner
              });
              TransportManager$1.bind(TransportManager$1.ON_READY, handleTransportManagerReady);
              ConnectionManager.bind(ConnectionManager.ON_STATE, handleConnectionManagerState);
              ConnectionManager.bind(ConnectionManager.ON_MESSAGE, handleConnectionManagerMessage);
              Demographics$1.bind(Demographics$1.ON_ADD_COUNTER, handleDemographicsCounter);
              _context.prev = 13;
              _context.next = 16;
              return fetch(configFile);

            case 16:
              response = _context.sent;
              status = response.status, text = response.statusText;
              _context.prev = 18;
              _context.next = 21;
              return response.json();

            case 21:
              data = _context.sent;
              _context.next = 28;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](18);
              self.trigger(self.ON_ERROR, "Invalid JSON from config ".concat(configFile));
              return _context.abrupt("return");

            case 28:
              isSuccess = status >= 200 && status <= 300 || // If you conclude with an XMLHttpRequest receiving status=0 and
              // statusText=null, this means the request was not allowed to be
              // performed.
              // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#xmlhttprequests_being_stopped
              status === 0 && !!text || status === '';
              data.forceSecure = forceSecure;

              if (data.background_timeout === undefined) {
                data.background_timeout = 0;
              }

              if (isSuccess) {
                ConnectionManager.init(data);
                TransportManager$1.init(data);
              } else {
                self.trigger(self.ON_ERROR, "Failed to load config ".concat(configFile));
              }

              _context.next = 37;
              break;

            case 34:
              _context.prev = 34;
              _context.t1 = _context["catch"](13);
              self.trigger(self.ON_ERROR, "Error loading config: ".concat(_context.t1.message));

            case 37:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[13, 34], [18, 24]]);
    }));

    function init() {
      return _init.apply(this, arguments);
    }

    return init;
  }();

  return self;
})();

export { Enmasse as default };
//# sourceMappingURL=index.esm2017.js.map
